import { render, staticRenderFns } from "./ButtonAddFileToTicket.vue?vue&type=template&id=cc000640&"
import script from "./ButtonAddFileToTicket.vue?vue&type=script&lang=ts&"
export * from "./ButtonAddFileToTicket.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports